import styled from 'styled-components'

export const Nav = styled.nav`
  top: 0;
  width: 100%;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  letter-spacing: 1em;
  justify-content: center;
  > a {
    display: inline-block;
    color: white;
    margin-right: 5px;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 5em;
    font-family: 'Arial Black', sans-serif;
    font-weight: 800;
    line-height: 0.75em;
  }
`
